const MENSAJES_PRESETS = [
  {
    etiqueta: "Completar perfil",
    texto: "Para publicar tu servicio debes completar los 5 pasos del formulario de registro. Puedes acceder desde tu panel principal en la aplicación.",
  },
  {
    etiqueta: "Sin trabajo disponible",
    texto: "La disponibilidad de servicios depende de la demanda en tu zona. Te recomendamos revisar la app con frecuencia, ya que los trabajos se publican constantemente.",
  },
  {
    etiqueta: "Ya estamos en ello",
    texto: "Hola, te saluda el equipo de soporte de Zervicy. Ya estamos revisando tu caso y te responderemos en breve. ¡Gracias por tu paciencia!",
  },
  {
    etiqueta: "Solicitud registrada",
    texto: "Tu solicitud fue registrada correctamente. En menos de 24 horas recibirás una respuesta de nuestro equipo de soporte.",
  },
  {
    etiqueta: "Revisar spam",
    texto: "Te pedimos que revises tu bandeja de spam o correo no deseado, ya que a veces nuestros correos llegan ahí. Si no encuentras el correo, cuéntanos.",
  },
  {
    etiqueta: "Cerrar sesión y entrar",
    texto: "Por favor intenta cerrar sesión en la aplicación y volver a ingresar. Si el problema persiste, cuéntanos con más detalle para ayudarte mejor.",
  },
  {
    etiqueta: "Actualizar la app",
    texto: "Te recomendamos verificar que tienes la versión más reciente de la aplicación. Puedes actualizarla desde la tienda de tu dispositivo (App Store o Google Play).",
  },
  {
    etiqueta: "Pago en revisión",
    texto: "Tu pago está siendo procesado. Esto puede tardar entre 1 y 3 días hábiles dependiendo de tu banco. Si el problema persiste, contáctanos de nuevo.",
  },
  {
    etiqueta: "Mejorar servicio",
    texto: "Lo que escribes en tu servicio es clave para que los compradores te elijan. Un título, descripción y paquetes bien completos hacen toda la diferencia; si están cortos o incompletos, otros vendedores te van a ganar la reserva.\n\nPuedes mejorarlo fácilmente:\n\n📝 *Descripción:* en el paso 2 hay un botón de IA. Solo cuéntale quién eres, qué haces y de qué trata tu servicio, y la IA escribe todo por ti. Luego tú editas lo que quieras.\n\n🖼️ *Imágenes:* sube fotos de buena calidad que muestren tu trabajo real.\n\n📦 *Paquetes:* si tu servicio dura 60 minutos, escribe 60 y el precio correspondiente. Nosotros añadimos un pequeño adicional que paga el comprador; puedes ver el desglose exacto en el botón que aparece justo al lado del precio.\n\nSi quieres, con gusto te ayudo a mejorar tu servicio, tú solo revisas y apruebas. ¿Te parece?",
  },
];

export default MENSAJES_PRESETS;
